<div class="atendimento-form" style="background-color: var(--modal-bg-escuro); padding: 2rem">
  <form [formGroup]="pesquisaBasicaForm" (ngSubmit)="mapeiaEnviaDados()" (keydown.enter)="mapeiaEnviaDados()">
    <h3 style="color: white; font-weight: bold;">Busca de conteúdo</h3>

    <lib-segov-sigepo-field-with-icon
      [idField]="'textoPesquisa'"
      data-test-id="textoPesquisa"
      [fieldType]="'text'"
      [placeHolderText]="'Informe o termo que deseja pesquisar'"
      [labelIcon]="'icons/search-line-input.svg'"
      [titleStyle]="'color: white; font-size: 20px'"
      [fieldTitle]="'Palavra ou frase:*'" [parent]="pesquisaBasicaForm"
      [fieldFormControl]="pesquisaBasicaForm.controls['texto']"
      [readyShowError]="true"
      [error]="pesquisaBasicaForm.controls['texto'].errors"
      [isValid]="pesquisaBasicaForm.controls['texto'].valid || !pesquisaBasicaForm.controls['texto'].dirty">
    </lib-segov-sigepo-field-with-icon>

    <div class="row" style="margin-top: 1rem;">
      <h5 style="color: white;">Período</h5>
      <div class="col-lg-6 col-12">
        <lib-segov-sigepo-field-with-icon
          [idField]="'periodoPesquisaInicial'"
          data-test-id="periodoPesquisaInicial"
          [fieldType]="'date'"
          [maxValue]="LimiteMaxData.toJSDate().toISOString().split('T')[0]"
          [labelIcon]="'icons/calendar-input.svg'"
          [titleStyle]="'color: white; font-size: 20px'"
          [fieldTitle]="'Data Inicial:*'" [parent]="pesquisaBasicaForm"
          [fieldFormControl]="pesquisaBasicaForm.controls['periodoDataInicial']"
          [readyShowError]="true"
          [error]="pesquisaBasicaForm.controls['periodoDataInicial'].errors"
          [isValid]="pesquisaBasicaForm.controls['periodoDataInicial'].valid || !pesquisaBasicaForm.controls['periodoDataInicial'].dirty">
        </lib-segov-sigepo-field-with-icon>
      </div>

      <div class="col-lg-6 col-12 periodo-final">
        <lib-segov-sigepo-field-with-icon
        [idField]="'periodoPesquisaFinal'"
        data-test-id="periodoPesquisaFinal"
        [fieldType]="'date'"
        [maxValue]="LimiteMaxData.toJSDate().toISOString().split('T')[0]"
        [labelIcon]="'icons/calendar-input.svg'"
        [titleStyle]="'color: white; font-size: 20px'"
        [fieldTitle]="'Data Final:*'"[parent]="pesquisaBasicaForm"
        [fieldFormControl]="pesquisaBasicaForm.controls['periodoDataFinal']"
        [readyShowError]="true"
        [error]="pesquisaBasicaForm.controls['periodoDataFinal'].errors"
        [isValid]="pesquisaBasicaForm.controls['periodoDataFinal'].valid || !pesquisaBasicaForm.controls['periodoDataFinal'].dirty">
      </lib-segov-sigepo-field-with-icon>
      </div>
    </div>

    <div style="color: white; font-size: 18px; padding-top: 1rem;">
      <span>Caderno:*</span>
      <div class="row">
        <span class="col-xl-4 col-lg-6 col-12" style="display: flex">
          <lib-segov-sigepo-forms-check-box
          formControlName="diarioExecutivo"
          data-test-id="diarioExecutivo"
          [customCheckboxOnStyle]="'color: var(--custom-checkbox-on)'"
          [customCheckboxOffStyle]="'color: var(--custom-checkbox-off)'"
          />
          Diário do Executivo
        </span>
        <span class="col-xl-4 col-lg-6 col-12" style="display: flex">
          <lib-segov-sigepo-forms-check-box
          formControlName="diarioMunicipiosMineiros"
          data-test-id="diarioMunicipiosMineiros"
          [customCheckboxOnStyle]="'color: var(--custom-checkbox-on)'"
          [customCheckboxOffStyle]="'color: var(--custom-checkbox-off)'"
          />
          Diário dos Municípios Mineiros
        </span>
        <span class="col-xl-4 col-lg-6 col-12" style="display: flex">
          <lib-segov-sigepo-forms-check-box
          formControlName="diarioJudiciario"
          data-test-id="diarioJudiciario"
          [customCheckboxOnStyle]="'color: var(--custom-checkbox-on)'"
          [customCheckboxOffStyle]="'color: var(--custom-checkbox-off)'"
          />
          Diário do Judiciário
        </span>
      </div>

      <div class="row">
        <span class="col-xl-4 col-lg-6 col-12" style="display: flex">
          <lib-segov-sigepo-forms-check-box
          formControlName="diarioTerceiros"
          data-test-id="diarioTerceiros"
          [customCheckboxOnStyle]="'color: var(--custom-checkbox-on)'"
          [customCheckboxOffStyle]="'color: var(--custom-checkbox-off)'"
          />
          Diário de Terceiros
        </span>
        <span class="col-xl-4 col-lg-6 col-12" style="display: flex">
          <lib-segov-sigepo-forms-check-box
          formControlName="diarioEdicaoExtra"
          data-test-id="diarioEdicaoExtra"
          [customCheckboxOnStyle]="'color: var(--custom-checkbox-on)'"
          [customCheckboxOffStyle]="'color: var(--custom-checkbox-off)'"
          />
          Edição Extra
        </span>
        <span class="col-xl-4 col-lg-6 col-12" style="display: flex">
          <lib-segov-sigepo-forms-check-box
          formControlName="diarioLegislativo"
          data-test-id="diarioLegislativo"
          [customCheckboxOnStyle]="'color: var(--custom-checkbox-on)'"
          [customCheckboxOffStyle]="'color: var(--custom-checkbox-off)'"
          />
          Diário do Legislativo
        </span>
      </div>
    </div>
    <hr>

    <div class="buttons-submit-group">
      <span class="limpar-filtros"
        data-test-id="limparFiltros"
        tabindex="0" (click)="limparFiltros()" (keyup.enter)="limparFiltros()">
        LIMPAR FILTROS
      </span>
      <button
        data-test-id="pesquisar"
        [class]="'button-pesquisar'"
        [disabled]="!validaForm()"
        [type]="'submit'">
        PESQUISAR
      </button>
    </div>
  </form>
</div>
